import { useCallback, useState } from "react";

/** Única chave de localStorage do sidebar (Cyber C6): só o booleano, nunca dado de usuário/tenant. */
const STORAGE_KEY = "sidebar-collapsed";

function readCollapsed(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

function writeCollapsed(value: boolean): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, value ? "true" : "false");
  } catch {
    // Sem storage (modo privado/bloqueado): o estado vale só para a sessão atual.
  }
}

/** Estado recolhido do sidebar, persistido entre sessões (S12). Padrão: expandido. */
export function useSidebarCollapsed(): [boolean, () => void] {
  const [collapsed, setCollapsed] = useState<boolean>(readCollapsed);

  const toggle = useCallback(() => {
    setCollapsed((current) => {
      const next = !current;
      writeCollapsed(next);
      return next;
    });
  }, []);

  return [collapsed, toggle];
}
